import React, { useState } from "react";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp,
  FaFacebook,
} from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

function ContactUs() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    countryCode: "+91",
    message: "",
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    try {
      const res = await fetch("https://formspree.io/f/xyzdvklw", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        alert("Message Sent Successfully!");
        setFormData({
          name: "",
          email: "",
          phone: "",
          countryCode: "+91",
          message: "",
        });
      } else {
        alert("Failed to send message. Please try again later.");
      }
    } catch {
      alert("An error occurred. Please try again later.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#02042b] mt-16 px-4 sm:px-6 lg:px-20 py-10 flex flex-col gap-8">

      {/* Floating WhatsApp */}
      <a
        href="https://wa.me/918981538013"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-40 bg-green-500 hover:bg-green-600 text-white p-3 sm:p-4 rounded-full shadow-lg text-2xl sm:text-3xl transition"
      >
        <FaWhatsapp />
      </a>

      <div className="flex flex-col lg:flex-row gap-6 lg:gap-10">

        {/* LEFT — Info */}
        <div className="text-white p-7 sm:p-10 rounded-xl shadow-2xl w-full lg:w-1/2 bg-[#1c1e48]">
          <h3 className="text-2xl sm:text-4xl font-extrabold bg-gradient-to-r from-blue-300 to-blue-200 text-transparent bg-clip-text text-center">
            📞 Contact Us
          </h3>

          <p className="mt-3 sm:mt-4 text-gray-300 text-sm sm:text-base text-center">
            Get in touch — our experts will help you with fast, reliable support.
          </p>

          {/* Social icons */}
          <div className="flex justify-center space-x-6 mt-6">
            <FaMapMarkerAlt className="text-[#60baff] text-2xl" />
            <FaWhatsapp className="text-[#25D366] text-2xl" />
            <FaFacebook className="text-[#1877F2] text-2xl" />
            <FaEnvelope className="text-[#60baff] text-2xl" />
          </div>

          <div className="mt-6 space-y-4 text-sm sm:text-base">
            <div className="flex items-start gap-3">
              <FaWhatsapp className="text-[#25D366] text-2xl" />
              <p>+91 89815 38013</p>
            </div>

            <div className="flex items-start gap-3">
              <FaEnvelope className="text-[#60baff] text-2xl" />
              <p>
                contact@infinitesolutionedu.com <br />
                infinitesolutionedu@gmail.com
              </p>
            </div>

            <div className="flex items-start gap-3 leading-relaxed">
              <FaMapMarkerAlt className="text-[#60baff] text-2xl" />
              <p>
                2nd Floor, Dainhat Bazar Paddarani Market,
                Purba Burdwan, West Bengal, India — 713502
              </p>
            </div>
          </div>
        </div>

        {/* RIGHT — Form */}
        <div className="bg-white/10 backdrop-blur-lg p-7 sm:p-10 rounded-xl shadow-lg w-full lg:w-1/2">
          <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6">

            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              className="w-full p-3 border border-gray-500 bg-transparent text-white rounded-lg placeholder-gray-200 focus:outline-none focus:border-[#60baff]"
              required
            />

            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Your Email"
              className="w-full p-3 border border-gray-500 bg-transparent text-white rounded-lg placeholder-gray-200 focus:outline-none focus:border-[#60baff]"
              required
            />

            <PhoneInput
              country={"in"}
              enableSearch
              value={formData.phone}
              onChange={(value) => setFormData({ ...formData, phone: value })}
              inputStyle={{
                width: "100%",
                backgroundColor: "rgba(255,255,255,0.3)",
                borderRadius: "0.5rem",
                border: "1px solid #6b7280",
                color: "#fff",
              }}
              containerStyle={{ width: "100%" }}
              dropdownStyle={{ color: "#000" }}
              inputProps={{
                name: "phone",
                required: true,
                placeholder: "Phone Number",
              }}
            />

            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Message"
              className="w-full p-3 border border-gray-500 bg-transparent text-white rounded-lg placeholder-gray-200 focus:outline-none focus:border-[#60baff] h-28 sm:h-32"
              required
            />

            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-gradient-to-r from-blue-600 to-blue-400 text-white font-bold p-3 rounded-lg hover:opacity-90 disabled:opacity-60 transition"
            >
              {submitting ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default ContactUs;
